import { Button, Card, Col, Divider, Form, Input, Row, Select, Typography } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { addIndivisualUser } from "../../redux/rtk/features/user/userSlice";
import { addClient } from "../../redux/rtk/features/usercopy/clientSlice";
import { statesData } from "../../utils/states";
import Footer from "../layouts/Footer";
import Main from "../layouts/Main";
import "./registerClient.css";

const { Option } = Select;

const RegisterClientOrStaff = () => {
  const [loader, setLoader] = useState(false);
  const [isOfficeRegister, setIsOfficeRegister] = useState(false);
  const [buttonClicked, setButtonClicked] = useState('user');
  const dispatch = useDispatch();
  const { Title } = Typography;
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      values.phone = `+91${values.phone}`;
      values.aPhone = `+91${values.phone}`;
      values.roleId = isOfficeRegister ? 1 : 3;

      console.log(values);

      if (isOfficeRegister) {
        const resp = await dispatch(addClient(values));
        setLoader(true);
        if (resp.payload && resp.payload.message === "success") {
          // setLoader(false);
          navigate("/admin/auth/login");
        } else {
          setLoader(false);
        }
      } else {
        // values.company_id = 2;
        const resp = await dispatch(addIndivisualUser(values));
        setLoader(true);
        if (resp.payload && resp.payload.message === "success") {
          navigate("/admin/auth/login");
        } else {
          setLoader(false);
        }
      }
      form.resetFields();
    } catch (error) {
      console.log(error.message);
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    console.log("Failed:", errorInfo);
  };

  return (
    <Main>
      <div className="container">
        <Row className="mr-top">
          <Col span={12} offset={4}>
            <Card bordered={false} className="circlebox h-full">
              <Title level={3} className="m-3 text-center">
                Register
              </Title>
              <div className="text-center mb-4">
                <Button
                  type={buttonClicked === 'office' ? 'primary' : 'default'}
                  onClick={() => { setIsOfficeRegister(true); setButtonClicked('office'); }}
                  className="mr-2"
                // icon={<OfficeOutlined />} // Add icon
                >
                  Office Registration
                </Button>
                <Button
                  type={buttonClicked === 'user' ? 'primary' : 'default'}
                  onClick={() => { setIsOfficeRegister(false); setButtonClicked('user'); }}
                  className="ml-2"
                // icon={<UserOutlined />} // Add icon
                >
                  Indivisual Registration
                </Button>
              </div>
              <Form
                form={form}
                className="m-4"
                name="basic"
                labelCol={{
                  span: 14,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                  country: 'India'
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                {isOfficeRegister ? (
                  <>
                    <div className="section-heading">Office Information</div>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="GST"
                          name="gst"
                          rules={[
                            {
                              required: true,
                              message: "Please input GST!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Company Name"
                          name="client_name"
                          rules={[
                            {
                              required: true,
                              message: "Please input company name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Email"
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "Please input email!",
                            },
                            { type: 'email', message: "Please enter a valid email!" },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Phone"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: "Please input phone!",
                            },
                            {
                              pattern: /^[0-9]{10}$/,
                              message: "Please enter a valid 10-digit phone number!",
                            },
                          ]}
                        >
                          <Input placeholder="Phone" maxLength={10} addonBefore="+91" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Address"
                          name="address"
                          rules={[
                            {
                              required: true,
                              message: "Please input street!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="City"
                          name="city"
                          rules={[
                            {
                              required: true,
                              message: "Please input city!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        {/* <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="State"
                          name="state"
                          rules={[
                            {
                              required: true,
                              message: "Please input state!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item> */}
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="State"
                          name="state"
                          rules={[
                            {
                              required: true,
                              message: "Please select a state!",
                            },
                          ]}
                        >
                          <Select placeholder="Select a state">
                            {statesData.states.map((state) => (
                              <Option key={state} value={state}>
                                {state}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="ZipCode"
                          name="zipCode"
                          rules={[
                            {
                              required: true,
                              message: "Please input zipCode!",
                            },
                            {
                              pattern: /^[0-9]{6}$/,
                              message: "Please enter a valid 6-digit Zip Code!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Country"
                          name="country"
                          rules={[
                            {
                              required: true,
                              message: "Please input country!",
                            },
                          ]}
                        >
                          <Input disabled/>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Divider className="custom-divider" />
                    <div className="section-heading">Admin Information</div>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="First Name"
                          name="firstName"
                          rules={[
                            {
                              required: true,
                              message: "Please input first name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Last Name"
                          name="lastName"
                          rules={[
                            {
                              required: true,
                              message: "Please input last name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="User Name"
                          name="userName"
                          rules={[
                            {
                              required: true,
                              message: "Please input username!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Password"
                          name="password"
                          rules={[
                            {
                              required: true,
                              message: "Please input password!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Admin Phone"
                          name="aPhone"
                          rules={[
                            {
                              required: true,
                              message: "Please input phone!",
                            },
                          ]}
                        >
                          <Input addonBefore="+91"
                            placeholder="Phone"
                            maxLength={10} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="First Name"
                          name="firstName"
                          rules={[
                            {
                              required: true,
                              message: "Please input first name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Last Name"
                          name="lastName"
                          rules={[
                            {
                              required: true,
                              message: "Please input last name!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="User Name"
                          name="userName"
                          rules={[
                            {
                              required: true,
                              message: "Please input username!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Password"
                          name="password"
                          rules={[
                            {
                              required: true,
                              message: "Please input password!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Email"
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "Please input email!",
                            },
                            { type: 'email', message: "Please enter a valid email!" },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Phone"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: "Please input phone!",
                            },
                            {
                              pattern: /^[0-9]{10}$/,
                              message: "Please enter a valid 10-digit phone number!",
                            },
                          ]}
                        >
                          <Input placeholder="Phone" maxLength={10} addonBefore="+91" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Street"
                          name="street"
                          rules={[
                            {
                              required: true,
                              message: "Please input street!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="City"
                          name="city"
                          rules={[
                            {
                              required: true,
                              message: "Please input city!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                      <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="State"
                          name="state"
                          rules={[
                            {
                              required: true,
                              message: "Please select a state!",
                            },
                          ]}
                        >
                          <Select placeholder="Select a state">
                            {statesData.states.map((state) => (
                              <Option key={state} value={state}>
                                {state}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="ZipCode"
                          name="zipCode"
                          rules={[
                            {
                              required: true,
                              message: "Please input zipCode!",
                            },
                            {
                              pattern: /^[0-9]{6}$/,
                              message: "Please enter a valid 6-digit Zip Code!",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          style={{ marginBottom: "10px" }}
                          label="Country"
                          name="country"
                          rules={[
                            {
                              required: true,
                              message: "Please input country!",
                            },
                          ]}
                        >
                          <Input disabled/>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  className="mb-2"
                  wrapperCol={{
                    offset: 6,
                    span: 16,
                  }}
                >
                  <Button
                    onClick={() => setLoader(true)}
                    block
                    type="primary"
                    htmlType="submit"
                    shape="round"
                    loading={loader}
                  >
                    Register
                  </Button>
                </Form.Item>
                <h6 className="text-center mt-2">
                  Already have an account ?{" "}
                  <Link to={"/admin/auth/login"}>Login Here</Link>
                </h6>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer />
    </Main>
  );
};

export default RegisterClientOrStaff;